import React from "react";
import { NotImplemented } from "pages/PayRoll/Shared/NotImplemented";

// Placeholder until Salary Holds is built. Reached from
// Payroll > Pay Inputs > Salary Holds in the sidebar flyout.
export const PayInputSalaryHolds = () => <NotImplemented title="Salary Holds" />;
